// Tenant configuration for Brandenburg (bb).
import { TenantConfig } from '@/tenants/types'

export const tenant: TenantConfig = {
  id: 'bb',
  name: 'Fifty-Fifty-Taxi Brandenburg',
  copyright: 'Copyright 2019-{currentYear} MIL',
  deleteAccountMailSubject: '5050 Taxi BB - Anfrage Kontolöschung',
}
